export enum ToastType {
  DEFAULT = 'default',
  INFO = 'info',
  SUCCESS = 'success',
  WARN = 'warn',
  ERROR = 'error'
}

export interface IToastProps {
  message: string;
}

export interface IToastContainer {
  bottomInset: string;
}

export interface IToastCloseProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export interface IToastViewProps {
  message: string;
  type: ToastType;
  closeToast?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
